import ApiCore from '../api-core'

import InventoryAccountSettings from './inventory-account-settings'
import InventoryProfileSettings from './inventory-profile-settings'
import CurrencySettings from './currency-settings'

import * as types from '@/store/types'

export default class Settings extends ApiCore {
  constructor (store) {
    const endpoint = 'public/settings'
    super(store, endpoint)

    this.inventoryAccount = new InventoryAccountSettings(store)
    this.inventoryProfile = new InventoryProfileSettings(store)
    this.currencySettings = new CurrencySettings(store)
  }

  getOffline (showProgress) {
    return this._request({
      action: 'offline',
      method: 'GET',
      showProgress
    })
  }

  get (keys) {
    if (typeof keys === 'string')
      keys = [keys]

    const refresh = keys.find(key => !this._store.state.$settings[key] || this._store.state.$settings[key] === null)

    if (refresh) {
      return this.refresh(keys)
    } else {
      const result = {}
      keys.forEach(k => {
        result[k] = this._store.state.$settings[k]
      })
      return Promise.resolve(result)
    }
  }

  refresh (keys) {
    if (typeof keys === 'string')
      keys = [keys]

    let promise = Promise.resolve()

    const model = {}
    keys.forEach(key => {
      model[key] = true
    })

    promise = this._request({
      method: 'GET',
      params: model
    })
    .then(res => {
      this._store.commit(types.SET_SETTINGS, res)
      return res
    })

    return promise
  }
}
